module.exports = __webpack_public_path__ + "static/Swift_logo-78fa05da29af429bc8e9dbc31bf3a703.png";